import { TwoColumnLayout } from 'layouts';
import type { ProgramEventContentObjectDetail } from 'models';
import { withErrorBoundary } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { ChannelsDetailCard } from 'features/channels/components/channels-detail-card';
import {
  EventActionsSocial,
  EventDetailCountdown,
  EventDetailDescription,
  EventDetailVideoRecording,
} from '../components';
import { EventFeedback, type EventFeedbackOptions } from '../event-feedback';
import { ProgramEventDetailAttachments } from './program-event-detail-attachments';
import { ProgramEventDetailComments } from './program-event-detail-comments';
import { ProgramEventDetailInvitees } from './program-event-detail-invitees';
import { ProgramEventDetailStatusMessage } from './program-event-detail-status-message';
import { ProgramEventDetailsCard } from './program-event-details-card';

type P = {
  eventContentObject: ProgramEventContentObjectDetail;
  feedbackOptions: EventFeedbackOptions;
};

const ProgramEventDetail = ({ eventContentObject, feedbackOptions }: P) => {
  const {
    author: { nodeUserId },
    event,
    organization,
  } = eventContentObject;

  return (
    <TwoColumnLayout
      left={
        <>
          <EventFeedback {...feedbackOptions} />
          <EventActionsSocial authorId={nodeUserId} event={event} view="detail" />
          <ProgramEventDetailStatusMessage eventContentObject={eventContentObject} />
          <EventDetailDescription eventId={event.id} htmlContent={event.htmlContent} />
          <EventDetailVideoRecording src={event.recordingUrl} status={event.recordingStatus} />
          <ProgramEventDetailComments eventContentObject={eventContentObject} />
        </>
      }
      right={
        <>
          <EventDetailCountdown changeRequests={event.changeRequests} startTime={event.startTime} />
          <ProgramEventDetailInvitees eventContentObject={eventContentObject} />
          <ProgramEventDetailAttachments event={event} />
          <ProgramEventDetailsCard eventContentObject={eventContentObject} />
          <ChannelsDetailCard
            channelAppearance={{
              featured: event.featuredInChannels,
              visible: event.showInChannels,
            }}
            channelTags={event.tags}
            organizationId={organization.id}
          />
        </>
      }
    />
  );
};

export default withErrorBoundary(ProgramEventDetail);
